import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UPDATE_DAYCARE_MEAL_MENU } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'
import { MealMenu } from '@/types/Meal.ts'

interface UpdateMealMenuDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
    menu: MealMenu
}

const UpdateMealMenuDialog: FunctionComponent<UpdateMealMenuDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId,
    menu
}: UpdateMealMenuDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [value, setValue] = useState<string>(menu.menu)

    useEffect(() => {
        setValue(menu.menu)
    }, [menu])

    const [updateMealMenu] = useMutation(UPDATE_DAYCARE_MEAL_MENU, {
        variables: { daycareId, menuId: menu.id, menu: value },
        onCompleted: () => {
            refetch()
            handleClose()
            showNotificationSuccess(t('mealMenuUpdated'))
        },
        onError: () => {
            handleClose()
            showNotificationError(t('mealMenuUpdatedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('updateMealMenu')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={value}
                    setValue={setValue}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 2, max: 255 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='confirm'
                        disabled={value.length < 2 || value.length > 255 || value === menu.menu}
                        onClick={() => updateMealMenu()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default UpdateMealMenuDialog
